import React from 'react'
import { BsChevronLeft } from 'react-icons/bs'
import { useNavigate } from 'react-router-dom'

export default function BtnBack2({ to = -1, text = 'Back', onClick }) {
  const navigate = useNavigate()

  const handleClick = () => {
    if (onClick) {
      onClick() // 👉 ใช้ logic จาก parent
    } else {
      navigate(to) // 👉 default behavior
    }
  }

  return (
    <h5
      className="btn-back-text my-auto text-decoration-none"
      style={{ color: 'var(--color-on-base-content-high)' }}
    >
      <BsChevronLeft
        onClick={handleClick}
        className="me-1 flex-shrink-0 pointer-event"
      />
      <span className="btn-back-text-label p-4">{text}</span>
    </h5>
  )
}
